export default "__VITE_ASSET__BOtfOdk6__"